<template>
    <div>
      <label>
        <input type="radio" name="option" value="True" v-model="selectedOption" />
        True
      </label>
      <label>
        <input type="radio" name="option" value="False" v-model="selectedOption" />
        False
      </label>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        selectedOption: "True",
      };
    },
  };
  </script>